<template>

<iframe height="700" style="width: 100%;" scrolling="no" title="For The Love Of Coffee" src="https://codepen.io/Farah-Kamal/embed/wvNgqLQ/f9301262294effcdb380988093aa18c3?default-tab=result&theme-id=47174" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true">
  See the Pen <a href="https://codepen.io/Farah-Kamal/pen/wvNgqLQ/f9301262294effcdb380988093aa18c3">
  For The Love Of Coffee</a> by Farah Kamal (<a href="https://codepen.io/Farah-Kamal">@Farah-Kamal</a>)
  on <a href="https://codepen.io">CodePen</a>.
</iframe>




</template>


